export const receiverDetailsInitialState = {
    accountName: '',
    accountNumber: '',
    action: undefined,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9SZWNlaXZlckRldGFpbHMvZm9ybS9zdGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRQSxNQUFNLENBQUMsTUFBTSwyQkFBMkIsR0FBeUI7SUFDN0QsV0FBVyxFQUFFLEVBQUU7SUFDZixhQUFhLEVBQUUsRUFBRTtJQUNqQixNQUFNLEVBQUUsU0FBUztDQUNwQixDQUFDIn0=